// extracted by mini-css-extract-plugin
module.exports = {"SplashScreen":"SplashScreen__SplashScreen___2019O","ContentWrapper":"SplashScreen__ContentWrapper___1Auru","LogoWrapper":"SplashScreen__LogoWrapper___1CBXl"};